// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"578":"0ec4af81","799":"0a4177ef"}[chunkId] + ".css";
};